import { exists } from '@engine/lib/utility/exists';
var selector = '#virtual_terminal_terminal_id input[name$="_transaction[terminal_id]"]';

var getInputElement = function getInputElement() {
  return $(selector);
};

var selectExists = function selectExists() {
  return exists(getInputElement());
};

var selectedTerminalId = function selectedTerminalId() {
  return getInputElement().val();
};

var selectedTerminalName = function selectedTerminalName() {
  return getInputElement().find('div[class$="singleValue"]').text();
};

var TerminalSelect = {
  selector: selector,
  getInputElement: getInputElement,
  exists: selectExists,
  selectedTerminalId: selectedTerminalId,
  selectedTerminalName: selectedTerminalName
};
export default TerminalSelect;